import type { StatusKind } from '@/components/Chips/StatusChip/StatusChip';
import { Dcr, DcrDisplayStatus } from '@/core/graphql/generated/types';

export const KIND_BY_DISPLAY_STATUS: Record<DcrDisplayStatus, StatusKind> = {
	[DcrDisplayStatus.ChangeAccepted]: 'accepted',
	[DcrDisplayStatus.ChangeRejected]: 'rejected',
	[DcrDisplayStatus.ChangePartial]: 'partial',
	[DcrDisplayStatus.ChangePendingreview]: 'pending',
	[DcrDisplayStatus.ChangeProcessing]: 'processing'
};

export const computeDcrStatus = (dcr: Pick<Dcr, 'displayStatus'>): StatusKind =>
	KIND_BY_DISPLAY_STATUS[
		dcr.displayStatus ?? DcrDisplayStatus.ChangeProcessing
	];
